import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { IPlandayUnitMatch } from '@fi-app/external-platform-integration/planday/planday';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';

@Component({
    selector: 'planday-match-units-with-areas',
    templateUrl: './planday-match-units-with-areas.component.html',
    styleUrls: ['./planday-match-units-with-areas.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-match-units-with-areas' },
    standalone: false,
})
export class PlandayMatchUnitsWithAreasComponent implements OnInit {
    @Input() areas: ILightWeightArea[];
    @Input() businessAreas: ILightWeightObject[];
    @Input() plandayUnitMatches: IPlandayUnitMatch[];

    @ViewChild(FiValidatingFormDirective, { static: true }) plandayMatchUnitsAreasForm: FiValidatingFormDirective;

    constructor(
        private plandayService: PlandayService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit(): void {
        this.saveChangesWarningService.start(() => this.plandayUnitMatches);
    }

    onMatchUnitsWithAreasChanged() {
        this.plandayMatchUnitsAreasForm.updateValidity();
    }

    savePlandayMatchUnitsAreas() {
        this.saveChangesWarningService.stop();
        this.plandayService.saveMatchUnitsWithAreas(this.plandayUnitMatches).then(() => {
            this.saveChangesWarningService.start(() => this.plandayUnitMatches);
        });
    }

    canSaveMatchUnitsAreas() {
        return !this.plandayMatchUnitsAreasForm.errors;
    }
}
